<template>
  <el-card class="h-full relative flex flex-col">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px mr-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入隐患描述"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.hiddenDangerSource"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患来源"
          clearable
        >
          <el-option
            v-for="item in hiddenSourceList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择区域"
          v-model="searchData.areaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerlevel"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患等级"
          clearable
        >
          <el-option
            v-for="item in hiddenLevelList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerCategory"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患类别"
          clearable
        >
          <el-option
            v-for="item in hiddenCategoryList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px"
          v-model="datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <!-- <el-select
          v-model="searchData.ownedSystemOrUnit"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择所属系统/机组"
          clearable
        >
          <el-option
            v-for="item in ownedSystemOrUnitList"
            :key="item.id"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-button size="small" class="mb-10px" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" class="mb-10px" @click="resetSearch">重置</el-button>
      </div>
      <div class="flex-auto h-0px">
        <el-table
          ref="table"
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="隐患描述"
            prop="hiddenDangerName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患等级"
            prop="hiddenDangerlevelStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="期限要求"
            prop="isCheckCorrect"
            min-width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.isCheckCorrect ? '立即整改' : '期限整改' }}
            </template>
          </el-table-column>
          <el-table-column
            label="隐患类别"
            prop="hiddenDangerCategoryStr"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column
            label="所在区域"
            prop="areaStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患来源"
            prop="hiddenDangerSourceStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="所属机组/系统"
            prop="ownedSystemOrUnitText"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="核实状态"
            prop="hazardVerificationStatusStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="隐患类型"
            prop="hiddenDangerTypeStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="安全检查标题"
            prop="safetyInspectionTitle"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="安全检查期数"
            prop="safetyInspectionPeriods"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="上报人"
            prop="reporterName"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="上报时间" prop="reportTime" show-overflow-tooltip width="180px">
            <template slot-scope="scope">
              {{
                scope.row.reportTime
                  ? dayjs(scope.row.reportTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="核实人"
            prop="hiddenDangerVerifierPersonName"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="核实时间"
            prop="hazardVerificationTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.hazardVerificationTime
                  ? dayjs(scope.row.hazardVerificationTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="140">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'read')"
                :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <el-button
                size="mini"
                :disabled="
                  !(
                    $hasAccess('update') &&
                    [0, 2].includes(scope.row.hazardVerificationStatus) &&
                    scope.row.auditPermission
                  )
                "
                @click="handleEvent(scope.row, 'update')"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>

    <HiddenVerifyForm
      v-if="formDialog"
      :formProps="formProps"
      :FormData="FormData"
      @refreshList="refreshList"
      @cancel="handleCancel"
    />
  </el-card>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import axios from 'axios'
import qs from 'qs'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'
import HiddenVerifyForm from '../../components/HiddenVerifyForm'

const areaApi = new AreaApi()

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'hidden-verify',
  components: {
    HiddenVerifyForm,
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      hiddenSourceList: [],
      ownedSystemOrUnitList: [],

      FormData: {},
      formDialog: false,
      detailDialog: false,
      datePickerValue: [],
      id: '',
      formProps: {
        title: '新增隐患排查计划',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  created() {
    const id = this.$route.query.id
    const flowTaskId = this.$route.query.taskId
    const currentWorkflowTaskId = this.$route.query.taskId
    // 待办-核实
    if (id && this.$route.query.mode) {
      this.initDialog(
        { id, currentWorkflowTaskId },
        this.$route.query.mode === 'approve' ? 'update' : 'read'
      )
    }
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
      ],
      this
    )
    this.searchList()
    this.getAreaList()
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.reportTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.reportTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.reportTimeStart = ''
        this.searchData.reportTimeEnd = ''
      }
    },
  },
  methods: {
    /**
     * 刷新列表
     */
    refreshList() {
      this.findList()
    },
    /**
     * 返回
     */
    async handleCancel() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.searchList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
        hazardVerificationStatus: [0,2] // 0：待核实，2：被驳回
      }
      // 低代码
      if (window.__POWERED_BY_QIANKUN__) {
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res1 = await instance.get(
          `/api/double-prevention-management/hidden-danger-rectification-checklists/paged-verification-list-query?${qs.stringify(
            data
          )}`
        )
        if (res1.status === 200 && res1.data) {
          this.tableData = res1.data.items
          this.total = res1.data.totalCount
          this.loading = false
        }
        return
      }
      const [err, res] =
        await hiddenDangerRectificationChecklistApi.hiddenDangersVerificationPagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'delete':
          this.$confirm('请确认是否删除计划？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerRectificationChecklistApi.callDelete(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'publish':
          this.$confirm('请确认是否发布该计划？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerRectificationChecklistApi.publishPlan({
                palanId: row.id,
              })
              if (!err) {
                this.$message.success('发布成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    async initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }隐患信息`
      if (operation === 'create') {
        this.FormData = this.$options.data().FormData
      } else {
        let resVal = {}
        if (window.__POWERED_BY_QIANKUN__) {
          // 低代码
          const instance = axios.create()
          instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
          const token = localStorage.getItem('authorization')
          instance.defaults.headers.common.Authorization = `Bearer ${token}`
          const result = await instance.get(
            `/api/double-prevention-management/hidden-danger-rectification-checklists/${row.id}`
          )
          if (result.status === 200 && result.data) {
            resVal = result.data
          }
        } else {
          const [err, res] = await hiddenDangerRectificationChecklistApi.get(row.id)
          if (!err) {
            resVal = res
          }
        }
        if (row.workflowTaskId) {
          resVal.workflowTaskId = row.workflowTaskId
        }
        if (row.currentWorkflowTaskId) {
          resVal.currentWorkflowTaskId = row.currentWorkflowTaskId
        }
        if (row.currentWorkflowDelayTaskId) {
          resVal.currentWorkflowDelayTaskId = row.currentWorkflowDelayTaskId
        }
        this.FormData = resVal
        this.FormData.isCanEdit = row.isCanEdit
        this.FormData.showNeedLeaderApprove = row.showNeedLeaderApprove
      }
      this.formDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
